export default __webpack_public_path__ + "static/media/operative.98204d69.png";